<template>
  <div>
    <v-list-item>
      <v-breadcrumbs :items="items" class="pa-3">
        <template v-slot:divider><v-icon>mdi-chevron-double-right</v-icon></template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item active-class="" :class="item.to?'text-body-2':'title'" :to="item.to">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
       <slot name="left"/>
      <v-spacer/>
      <v-spacer/>
      <slot/>
      <v-spacer/>
      <v-spacer/>
      <slot name="right"/>
    </v-list-item>
    <v-divider/>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
	props: {
    back: {type:Array,required:false,default:()=>[]},
    home: {type:String,required:true}
  },
  data() {
    return {
      items: []
    }
  },
  watch: {
    home() {
      this.items[this.items.length-1].text = this.home;
    },
    back() {
      this.items = [...this.back, {text:this.home}];
    }
  },
  created() {
    this.items = [...this.back, {text:this.home}];
  }
}
</script>